import { createContext, useContext, useEffect, useState } from 'react'

import { OnboardingContext } from '@/context/OnboardingContext'
import { getEnhancedUjwt } from '@/api/onboarding'

const IMAGE_MFE_URL = import.meta.env.VITE_IMAGE_MFE_URL;

export const ImageLibraryContext = createContext()

export const useImageLibrary = () => {
  return useContext(ImageLibraryContext)
}

const ImageLibraryProvider = ({ children }) => {
  const [isLoaded, setIsLoaded] = useState(false)
  const { productInstanceId } = useContext(OnboardingContext)
  const [token, setToken] = useState(null)

  const getToken = async () => {
    const res = await getEnhancedUjwt(productInstanceId)
    setToken(res)
    return res
  }

  useEffect(() => {
    if (productInstanceId?.length > 0) {
      getToken()
    }
  }, [productInstanceId])

  useEffect(() => {
    if (document.getElementById('image-library-mfe-loader')) {
      setIsLoaded(true)
      return
    }
    const script = document.createElement('script')
    script.async = true
    script.id = 'image-library-mfe-loader'
    script.type = 'text/javascript'
    script.src = IMAGE_MFE_URL
    script.onload = async () => {
      StandAloneImageLibraryLoader.loadScripts('image-library-mfe@1').then(() => {
        setIsLoaded(true)
      })
    }
    document.body.appendChild(script)
  }, [])
  return (
    <ImageLibraryContext.Provider value={{ isLoaded: isLoaded && token, token, getToken }}>
      {children}
    </ImageLibraryContext.Provider>
  )
}

export default ImageLibraryProvider
